//ReactDOM.render(<App />, document.getElementById('root'));
import { createBrowserHistory } from "history";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/nova-light/theme.css";
import React from "react";
import "react-block-ui/style.css";
import { render } from "react-dom";
//import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { unregister } from "./registerServiceWorker";
import { store } from "./store";

if (process.env.REACT_APP_SHOW_CONSOLE_LOG === 'false'){
  console.log = function (...params) {};
}

unregister();
let app = document.getElementById("root");

const history = createBrowserHistory();

if (app) {
  const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];

  if (path) {
    history.replace(path);
  }

  render(
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>,
    app
  );
}

/*
render(
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById("root")
);
*/
